import React, { useState, useEffect, useRef, Fragment } from 'react'
import { userIcon } from '@assets/images'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useOnClickOutside } from '@services/layout'
import styled from 'styled-components'
import { useUser } from '@state/uses/users'
import { getCurrentUser } from '@state/actions/users'
import DropDownLogin from '@components/DropDownLogin'
import DropdownLanguages from '@components/DropdownLanguages'
import i18n from '@localization/i18n'
import { hebrew, english } from '@assets/images'
import { useLanguage } from '@state/uses/app'

const UserButton = ({ onClick }) => {
    const language = useLanguage()
    const dispatch = useDispatch()
    const user = useUser()
    const history = useHistory()
    const ref = useRef()
    const [menuDropdownVisible, setMenuDropdownVisible] = useState(false)
    const [langDropdownVisible, setLangDropdownVisible] = useState(false)

    useEffect(() => {
        dispatch(getCurrentUser())
    }, [])

    const toggleLanguageMemu = () => {
        setLangDropdownVisible(!langDropdownVisible)
        setMenuDropdownVisible(false)
    }

    const toggleUserDropDown = () => {
        setMenuDropdownVisible(!menuDropdownVisible)
        setLangDropdownVisible(false)
    }
    useOnClickOutside(ref, () => {
        setLangDropdownVisible(false)
        setMenuDropdownVisible(false)
    })

    const goToLogin = () => {
        history.push({ pathname: '/login' })
    }

    const hebrewMenu = (
        <Fragment>
            <img
                src={userIcon}
                height="20"
                width="20"
                onClick={user ? toggleUserDropDown : goToLogin}
            />
            {!user && (
                <LoginText onClick={goToLogin}>
                    {i18n.t('login.log_in')}
                </LoginText>
            )}
            {user && (
                <WelcomeText onClick={toggleUserDropDown}>
                    {' '}
                    {i18n.t('headers.hello')}, {user.first_name}
                </WelcomeText>
            )}
            <LangImage
                resizeMode="stretch"
                src={i18n.locale === 'he' ? hebrew : english}
                onClick={toggleLanguageMemu}
            />
        </Fragment>
    )

    const englishMenu = (
        <Fragment>
            <LangImage
                resizeMode="stretch"
                src={i18n.locale === 'he' ? hebrew : english}
                onClick={toggleLanguageMemu}
            />
            {!user && (
                <LoginText onClick={goToLogin}>
                    {i18n.t('login.log_in')}
                </LoginText>
            )}
            {user && (
                <WelcomeText onClick={toggleUserDropDown}>
                    {' '}
                    {i18n.t('headers.hello')}, {user.first_name}
                </WelcomeText>
            )}
            <img
                src={userIcon}
                height="20"
                width="20"
                onClick={user ? toggleUserDropDown : goToLogin}
            />
        </Fragment>
    )

    return (
        <UserBtn ref={ref}>
            {language === 'he' ? hebrewMenu : englishMenu}
            <DropDownLogin
                onClick={user ? toggleUserDropDown : goToLogin}
                show={menuDropdownVisible}
                close={toggleUserDropDown}
            />
            <DropdownLanguages
                langDropdownVisible={langDropdownVisible}
                setLangDropdownVisible={setLangDropdownVisible}
                onClick={toggleLanguageMemu}
                show={langDropdownVisible}
                close={toggleLanguageMemu}></DropdownLanguages>
        </UserBtn>
    )
}

export default UserButton
const LangImage = styled.img`
    position: relative;
    width: 25px;
    margin-left: 10px;
    margin-right: 5px;
    cursor: pointer;
    display: flex;
    flex: 1;
    margin-top: 5px;
`

const LoginText = styled.div`
    margin: 0px 8px;
`

const UserBtn = styled.button`
    background-color: transparent;
    position: relative;
    width: auto;
    display: flex;
    direction: rtl;
    font-size: 15px;
    line-height: 1;
    height: 50px;
    color: #ffffff;
    align-items: center;
    border: none;
    cursor: pointer;
`

const WelcomeText = styled.div`
    margin: 0px 8px;
    background-color: transparent;
    font-size: 15px;
    color: #ffffff;
    display: block;
`
